/* eslint-disable no-lone-blocks,consistent-return,react-hooks/exhaustive-deps,no-restricted-globals */
import React, { useEffect, useState } from "react";
import { Button, Row, Table, Tooltip, DatePicker, Input, Spin, Form } from "antd";
import "../../styles/filters-form.less";
import "./Currencies.less";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import {
  displayFormat,
  toDisplayFormat,
  toDisplayFormatWithTime,
  toHttpFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { expandedTableEyeIcon } from "../../lib/icons";
import { buildQueryStringWithObjectParams } from "../../lib/utils";
import {
  fetchCurrencies,
  fetchCurrenciesVersionsPageable,
  updateCurrenciesVersions,
  deleteCurrenciesVersions,
} from "../../store/slices/currencies";
import tickIcon from "../../img/done.svg";
import deleteIcon from "../../img/delete-round.svg";
import pencilWithPlusIcon from "../../img/pencil-plus.svg";
import edit from "../../img/edit.svg";
import { getCurrenciesVersionsPageableRoute } from "../../lib/routes/currencies";
import tenantIdCodes from "../../lib/const/tenantIdCodes";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { MENU_ADMIN_EXCHANGE_WRITE } from "../../lib/const/permissions";
import { hasAccess } from "../RolesModule/hasAccess";
import { ReactComponent as DotsIcon } from "../../img/3dots.svg";
import HistoryAndPropertyModal from "../HistoryAndPropertyModal/HistoryAndPropertyModal";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";

const getTenant = (tenantId) => {
  if (tenantId === tenantIdCodes.kazakhstan) {
    return "RUB";
  }
  if (tenantId === tenantIdCodes.russia) {
    return "KZT";
  }
};

const Currencies = ({
  currenciesData,
  currenciesDataLoading,
  dicCurrencies,
  dicCurrenciesLoading,
}) => {
  const { currenciesDataVersionsPageable, currenciesDataVersionsPageableLoading } = useSelector(
    (state) => state.currencies
  );
  const { tenant } = useSelector((state) => state.tenants);
  const { defaultCurrencyId } = tenant;

  const dispatch = useDispatch();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [currencyVersionId, setCurrencyVersionId] = useState(null);
  const [dataVersion, setDataVersion] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [object, setObject] = useState("");
  const [isLoadedAdditionalVersions, setIsLoadedAdditionalVersions] = useState(
    rtkRequestStatusCodes.idle
  );
  const [isNextPage, setIsNextPage] = useState(true);

  const [form] = Form.useForm();

  const [currencyVersionsSearchParams] = useState({
    page: 0,
    size: 20,
    sort: ["fromDate", "desc"],
    param: "",
  });

  const [currencyRequestBody, setCurrencyRequestBody] = useState({
    id: null,
    fromDate: " ",
    toDate: " ",
    currencyId: null,
    rateTypeId: null,
    rate: null,
    tenantId: null,
    reverseRate: null,
  });
  const [editingKey, setEditingKey] = useState(null);
  const [formCurrencyEditStatus, setFormCurrencyEditStatus] = useState("idle");
  const isEditing = (rec) => rec.key === editingKey;
  const isEditingCurrencyToDate = formCurrencyEditStatus === "editingCurrencyToDate";
  const isEditingCurrencyRate = formCurrencyEditStatus === "editingCurrencyRate";
  const isMakingNewCurrencyVersion = formCurrencyEditStatus === "createNewVersion";
  const nowDate = toHttpFormat(moment());

  const isLoaded = checkIsLoaded(dicCurrenciesLoading, currenciesDataLoading);

  const isLoadedInner = checkIsLoading(currenciesDataVersionsPageableLoading);

  const queryString = `?${buildQueryStringWithObjectParams(currencyVersionsSearchParams)}`;

  useEffect(() => {
    setDataVersion(
      checkIsLoaded(currenciesDataVersionsPageableLoading) &&
        currenciesDataVersionsPageable?.content.map((item, index) => ({
          ...item,
          key: String(`${index}prop`),
          id: item.id,
          name:
            dicCurrencies &&
            dicCurrencies.find((currency) => currency.id === item?.currencyId)?.name,
          fromCurrency:
            dicCurrencies &&
            dicCurrencies.find((currency) => currency.id === item?.currencyId)?.abbrev,
          toCurrency: getTenant(item.tenantId),
          rate: item.rate,
          reverseRate: item.reverseRate,
          currentDate: moment().isBetween(item.fromDate, item.toDate),
          pastDate: moment(item.fromDate).isBefore(nowDate),
          futureDate: moment(item.fromDate).isAfter(nowDate),
          tenantId: item.tenantId,
          rateTypeId: item.rateTypeId,
          currencyId: item.currencyId,
          fromDateForRequestBody: item.fromDate,
          toDateForRequestBody: item.toDate,
          lastVersion: String(index) === String(0) ? "lastVersion" : "",
        }))
    );
  }, [currenciesDataVersionsPageable]);

  const handleShowModal = (objId) => {
    setObject(objId);
  };

  const handleHideModal = () => {
    setObject("");
  };

  const handleSearchCurrencies = async (page) => {
    setPageNum(page + 1);
    setIsLoadedAdditionalVersions(rtkRequestStatusCodes.pending);
    try {
      const { data } = await axios(
        [
          getCurrenciesVersionsPageableRoute(currencyVersionId),
          `?page=${pageNum}&size=20&sort=fromDate%2Cdesc`,
        ].join("")
      );

      const newData = data.content.map((item, index) => ({
        key: String(`${index}prop${page}`),
        id: item.id,
        name:
          dicCurrencies && dicCurrencies.find((currency) => currency.id === item?.currencyId)?.name,
        fromCurrency:
          dicCurrencies &&
          dicCurrencies.find((currency) => currency.id === item?.currencyId)?.abbrev,
        toCurrency: getTenant(item.tenantId),
        rate: item.rate,
        reverseRate: item.reverseRate,
        fromDate: item.fromDate ? toDisplayFormatWithTime(item.fromDate) : "",
        toDate: item.toDate ? toDisplayFormatWithTime(item.toDate) : "",
        currentDate: moment().isBetween(item.fromDate, item.toDate),
        pastDate: moment(item.fromDate).isBefore(nowDate),
        futureDate: moment(item.fromDate).isAfter(nowDate),
        tenantId: item.tenantId,
        rateTypeId: item.rateTypeId,
        currencyId: item.currencyId,
        fromDateForRequestBody: item.fromDate,
        toDateForRequestBody: item.toDate,
      }));

      const pageTotal = data?.totalPages;
      if (pageTotal === pageNum + 1) {
        setIsNextPage(false);
      } else {
        setIsNextPage(true);
      }

      setDataVersion((prev) => [...prev, ...newData]);
      setIsLoadedAdditionalVersions(rtkRequestStatusCodes.fulfilled);
    } catch (e) {
      setIsLoadedAdditionalVersions(rtkRequestStatusCodes.rejected);
    }
  };

  const columnsInner = [
    {
      title: "Валюта",
      dataIndex: "name",
      key: "name",
      width: "25%",
    },
    {
      title: "Код",
      dataIndex: "fromCurrency",
      key: "fromCurrency",
      width: "15%",
    },
    {
      title: "Обменный курс",
      dataIndex: "rate",
      key: "rate",
      width: "15%",
      render: (val, record) => {
        const editable = isEditing(record);

        const onChangeRate = (e) => {
          const { value } = e.target;
          const reg = /^-?\d*(\.\d*)?$/;
          if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
            setCurrencyRequestBody({ ...currencyRequestBody, rate: value });
          }
        };

        return editable ? (
          <Form.Item
            className="form-item-required__hidden-error__mb0"
            initialValue={isEditingCurrencyRate ? val : ""}
            name="rate"
            rules={[
              {
                required: true,
              },
              {
                pattern: /^(|[0-9]*[.]?[0-9])+$/,
              },
            ]}
          >
            <Input
              placeholder="Введите число"
              onChange={onChangeRate}
              value={currencyRequestBody.rate}
              // defaultValue={currencyRequestBody.rate}
            />
          </Form.Item>
        ) : (
          <>{val}</>
        );
      },
    },
    {
      title: "Обратный курс",
      dataIndex: "reverseRate",
      key: "reverseRate",
      width: "15%",
    },
    {
      title: "Период действия",
      key: "perod",
      render: (v, record) => {
        const editable = isEditing(record);

        if (editable && isMakingNewCurrencyVersion) {
          const defaultValue = moment(record.fromDate).add(1, "day");
          const onChangeDate = (e) => {
            setCurrencyRequestBody({
              ...currencyRequestBody,
              fromDate: toHttpFormatStartOfDay(e),
            });
          };
          const disabledDate = (current) => current < defaultValue || current > defaultValue;

          return (
            <>
              <DatePicker
                format={displayFormat}
                onChange={onChangeDate}
                defaultValue={defaultValue}
                disabledDate={disabledDate}
                disabled
                allowClear={false}
              />
              <span>{` - ${toDisplayFormat(record.toDate)}`}</span>
            </>
          );
        }

        if (editable && isEditingCurrencyToDate) {
          const onChangeDate = (e) => {
            setCurrencyRequestBody({
              ...currencyRequestBody,
              toDate: toHttpFormatEndOfDay(e),
            });
          };

          return (
            <>
              <span>{`${toDisplayFormat(record.fromDate)} - `}</span>
              <DatePicker
                format={displayFormat}
                onChange={onChangeDate}
                defaultValue={moment(record.toDate)}
                disabledDate={(current) => current < moment(record.fromDate)}
                allowClear={false}
              />
            </>
          );
        }
        return `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`;
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      render: (val, record, index) => {
        const editable = isEditing(record);
        const disabled =
          isMakingNewCurrencyVersion || isEditingCurrencyToDate || isEditingCurrencyRate;

        const handleEdit = (currencyEditStatus) => () => {
          form.resetFields();
          const fromDateParse = toHttpFormatStartOfDay(record.fromDate);
          const rateValue = record.rate;
          setCurrencyRequestBody({
            ...currencyRequestBody,
            rate: rateValue,
            fromDate: fromDateParse,
          });

          setEditingKey(() => record.key);
          setFormCurrencyEditStatus(currencyEditStatus);
        };

        const addNewVersion = (currencyEditStatus) => () => {
          form.resetFields();
          const fromDateParse = toHttpFormatStartOfDay(moment(record.fromDate).add(1, "day"));

          setCurrencyRequestBody({
            ...currencyRequestBody,
            fromDate: fromDateParse,
          });
          setEditingKey(() => `new${record.key}`);
          setFormCurrencyEditStatus(currencyEditStatus);

          const newRecord = {
            ...dataVersion[index],
            key: `new${dataVersion[index].key}`,
          };

          setDataVersion((prev) => [...prev.slice(0, index), newRecord, ...prev.slice(index)]);
        };

        const handleCancel = () => {
          form.resetFields();
          setEditingKey(null);
          if (isMakingNewCurrencyVersion)
            setDataVersion((prev) => [...prev.slice(0, index), ...prev.slice(index + 1)]);

          setFormCurrencyEditStatus("idle");
          setCurrencyRequestBody({ ...currencyRequestBody, rate: null });
        };

        const handleSubmit = () => {
          form.validateFields().then(async () => {
            const dataCreate = {
              ...currencyRequestBody,
              id: record.id,
              fromDate: isMakingNewCurrencyVersion
                ? currencyRequestBody.fromDate
                : record.fromDateForRequestBody,
              toDate: record.toDateForRequestBody,
              currencyId: record.currencyId,
              rateTypeId: record.rateTypeId,
              rate: Number(currencyRequestBody.rate),
              tenantId: record.tenantId,
              reverseRate: record.reverseRate,
            };

            if (isEditingCurrencyToDate)
              await dispatch(
                deleteCurrenciesVersions({
                  id: record.id,
                  onDate: currencyRequestBody.toDate,
                })
              );
            if (isMakingNewCurrencyVersion)
              await dispatch(
                updateCurrenciesVersions({
                  flag: false,
                  onDate: currencyRequestBody.fromDate,
                  values: dataCreate,
                })
              );
            if (isEditingCurrencyRate)
              await dispatch(
                updateCurrenciesVersions({
                  flag: true,
                  onDate: record.fromDateForRequestBody,
                  values: dataCreate,
                })
              );

            await dispatch(fetchCurrencies());
            await dispatch(
              fetchCurrenciesVersionsPageable({
                id: currencyVersionId,
                queryString,
              })
            );
            form.resetFields();
            setEditingKey(null);
            setFormCurrencyEditStatus("idle");
            setPageNum(1);
            setIsNextPage(true);
            setCurrencyRequestBody({ ...currencyRequestBody, rate: null });
          });
        };

        {
          if (hasAccess(MENU_ADMIN_EXCHANGE_WRITE))
            return editable ? (
              <div style={{ textAlign: "right" }}>
                <Tooltip title="Подтвердить">
                  <Button
                    icon={<img src={tickIcon} alt="tick" width="16px" />}
                    className="icon"
                    type="text"
                    htmlType="button"
                    onClick={handleSubmit}
                    // disabled={disabledCreate || disabledRate}
                  />
                </Tooltip>
                <Tooltip title="Отменить">
                  <Button
                    icon={<img src={deleteIcon} width="16px" alt="delete" />}
                    type="text"
                    className="icon"
                    htmlType="button"
                    onClick={handleCancel}
                  />
                </Tooltip>
              </div>
            ) : (
              <div style={{ textAlign: "right" }}>
                <Tooltip title="Добавить версию">
                  {record.lastVersion && (
                    <Button
                      icon={<img src={pencilWithPlusIcon} alt="pencil with plus" width="16px" />}
                      type="text"
                      htmlType="button"
                      onClick={addNewVersion("createNewVersion")}
                      disabled={disabled}
                    />
                  )}
                </Tooltip>

                <Tooltip title="Редактировать">
                  <Button
                    icon={<img src={edit} alt="pencil" width="16px" />}
                    type="text"
                    htmlType="button"
                    disabled={disabled}
                    onClick={handleEdit("editingCurrencyRate")}
                  />
                </Tooltip>
              </div>
            );
        }
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      width: "2%",
      render: (record) => (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleShowModal(record);
          }}
          className="button-icon iconButton"
          style={{ outline: "none", cursor: "pointer" }}
          icon={<DotsIcon />}
        />
      ),
    },
  ];

  const buildRowClassName = (record) => {
    const editable = isEditing(record);
    const editNew = record.key.includes("new");
    const activeClassName = "currency-version-row";

    if (record.currentDate && !editable) return `${activeClassName} current-date`;
    if (record.currentDate && editable && !editNew)
      return `${activeClassName} current-date active-row`;
    if (record.currentDate && editable && editNew)
      return `${activeClassName} current-date active-row new-prop`;
    if (record.pastDate && !editable) return `${activeClassName} past-date`;
    if (record.pastDate && editable) return `${activeClassName} past-date active-row`;
    if (record.futureDate && !editable) return `${activeClassName} future-date`;
    if (record.futureDate && editable) return `${activeClassName} future-date active-row`;
  };

  const innerTable = () => {
    if (!isLoadedInner) {
      return (
        <div className="version-inner-table">
          <Form form={form}>
            <Table
              className="inner-table"
              size="small"
              columns={columnsInner}
              dataSource={dataVersion}
              pagination={false}
              showHeader={false}
              rowClassName={buildRowClassName}
              loading={isLoadedInner}
            />
          </Form>
          {dataVersion && (
            <div className="table-row" style={{ textAlign: "center" }}>
              <Button
                style={{ minWidth: "120px" }}
                onClick={() => handleSearchCurrencies(pageNum)}
                disabled={
                  currenciesDataVersionsPageable.totalPages ===
                    currenciesDataVersionsPageable.number + 1 || !isNextPage
                }
              >
                {!checkIsLoading(isLoadedAdditionalVersions) ? (
                  "Загрузить ещё"
                ) : (
                  <Spin className="spin" />
                )}
              </Button>
            </div>
          )}
        </div>
      );
    }
    return <Spin className="spin" />;
  };

  let tableData;

  if (checkIsLoaded(currenciesDataLoading)) {
    tableData = currenciesData.map((item) => ({
      ...item,
      key: item.id,
      id: item.id,
      name:
        dicCurrencies && dicCurrencies.find((currency) => currency.id === item?.currencyId)?.name,
      fromCurrency:
        dicCurrencies && dicCurrencies.find((currency) => currency.id === item?.currencyId)?.abbrev,
      toCurrency: getTenant(item.tenantId),
      rate: item.rate,
      reverseRate: item.reverseRate,
    }));
  }

  const columns = [
    {
      title: "Валюта",
      dataIndex: "name",
      key: "name",
      width: "25%",
    },
    {
      title: "Код",
      dataIndex: "fromCurrency",
      key: "fromCurrency",
      width: "15%",
    },
    {
      title: "Обменный курс",
      dataIndex: "rate",
      key: "rate",
      width: "15%",
    },
    {
      title: "Обратный курс",
      dataIndex: "reverseRate",
      key: "reverseRate",
      width: "15%",
    },
    {
      title: "Период действия",
      key: "period",
      render: (v, record) =>
        `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`,
    },
    {
      title: "",
      dataIndex: "",
      key: "x",
      width: "2%",
      render: (record) => (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleShowModal(record);
          }}
          className="button-icon iconButton"
          style={{ outline: "none", cursor: "pointer" }}
          icon={<DotsIcon />}
        />
      ),
    },
  ];

  return (
    <div className="inner-row">
      <Row justify="space-between" align="middle">
        <h4 style={{ height: 25 }}>
          Курсы валют к{" "}
          {versionsTableUtils.geDicValueById(dicCurrencies, defaultCurrencyId)?.abbrev}
        </h4>
      </Row>
      <>
        <Table
          className="version-table currency-version-table"
          size="small"
          columns={columns}
          dataSource={tableData}
          pagination={false}
          loading={!isLoaded}
          rowClassName={(record) =>
            record.isActive === false ? "dictionary__disabled-date" : "dictionary__enabled-date"
          }
          expandIconColumnIndex={columns.length - 1}
          expandedRowKeys={expandedRowKeys}
          expandedRowRender={() => <>{innerTable()}</>}
          expandIcon={({ expanded, record }) => {
            const handleClick = (e) => {
              form.resetFields();
              setDataVersion("");
              setPageNum(1);
              setIsNextPage(true);
              e.stopPropagation();
              if (!expanded) {
                setExpandedRowKeys([record.key]);
                setCurrencyVersionId(record.id);
                setFormCurrencyEditStatus("idle");
                setEditingKey(null);
                dispatch(
                  fetchCurrenciesVersionsPageable({
                    id: record.id,
                    queryString,
                  })
                );
              } else {
                setExpandedRowKeys([]);
              }
            };
            return (
              <div className="version-table__eye-wrapper">
                <Button
                  icon={expandedTableEyeIcon(expanded ? "#0E5298" : "#86ACD2")}
                  onClick={handleClick}
                  type="text"
                  htmlType="button"
                  className="iconButton"
                />
              </div>
            );
          }}
        />
        <HistoryAndPropertyModal
          objectTypeSysname="currency_rate"
          objectId={object?.id}
          handleHideModal={handleHideModal}
          visibleModal={object?.id}
          dateObjectFromForCalendar={object?.fromDate}
          dateObjectToForCalendar={object?.toDate}
          hasAccessToEdit={hasAccess(MENU_ADMIN_EXCHANGE_WRITE)}
        />
      </>
    </div>
  );
};

export default Currencies;
